export default __webpack_public_path__ + "static/media/nate.4f3466e5.jpg";